import React from 'react';
import { Icon } from './Icon.js';
export const IconBedFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M17,12v-3.25c0-1.517-1.233-2.75-2.75-2.75h-5.5c-.414,0-.75,.336-.75,.75v5.25h9Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M16.25,11.5H2.5V3.25c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75V14.75c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-1.75H15.5v1.75c0,.414,.336,.75,.75,.75s.75-.336,.75-.75v-2.5c0-.414-.336-.75-.75-.75Z", fill: "currentColor" }),
        React.createElement("circle", { cx: "5.25", cy: "8.75", r: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconBedFill18.js.map